import React, { Component } from 'react';
import "../styles/customerQuote.css";

export default class WebscreenMobile extends Component {
  render() {
    return (
      <div className="customer-quote">
        <div className="medium-max-width-container">
          <div className="customer-quote-content large-padding">
            <img alt="" className="customer-quote-thumb" src={this.props.thumb} />
            <p className="customer-quote-text">{this.props.quote}</p>
            <h6 className="customer-quote-name">{this.props.name}</h6>
          </div>
        </div>
        <div className="customer-quote-tint" style={{backgroundColor:this.props.overlayColor}}></div>
        <div className="customer-quote-background" style={{backgroundImage: "url(" + this.props.backgroundImage + ")"}}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/customerQuote.js